import React, { useCallback } from 'react';
import OutsideFormInput from 'components/Input/OutsideFormInput';

interface IToucanLoginField {
	value: string;
	settingsId: string;
	onChange: (value: string) => void;
}

const ToucanLoginField: React.FC<IToucanLoginField> = ({ onChange, value, settingsId }) => {
	const handleChange = useCallback(
		(value: string) => {
			onChange(value.trim());
		},
		[onChange],
	);

	return (
		<OutsideFormInput
			testId="ToucanLoginField"
			name="login"
			label="loginLabel"
			errorMessage="enterLogin"
			blockId={settingsId}
			value={value}
			onChange={handleChange}
		/>
	);
};

export default React.memo(ToucanLoginField);
